{
  "marketing": {
    "footerProduct": "제품",
    "navForDevelopers": "개발자용",
    "navForPm": "PM용",
    "navHome": "홈",
    "navOpenApp": "앱 열기 →",
    "navStart": "무료로 시작 →",
    "navPricing": "가격"
  },
  "homepage": {
    "edition": "VOL. 1 · 2026 에디션",
    "footerBlurb": "에이전트 네이티브 아이디어 인큐베이터. 자체 호스팅 Rust 에이전트, Postgres + pgvector, S3 기반 refs 위에 구축. 클로즈드 소스 SaaS — 원하면 언제든 데이터를 markdown으로 내보낼 수 있습니다.",
    "footerSignIn": "로그인",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerMagicLink": "매직 링크",
    "footerEdition": "VOL. 1 · ISSUE 1 · 글로벌 얼리 액세스 · 2026 에디션",
    "footerPrivacy": "개인정보처리방침",
    "footerTerms": "이용약관",
    "footerContact": "문의"
  }
}
